import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import "./PageTemplate.css";
import styles from "./Impact.module.css";

const Impact: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const formatDescription = (text: string) => {
    return text.split("\n\n").map((paragraph, index, array) => (
      <React.Fragment key={index}>
        {paragraph}
        {index < array.length - 1 && (
          <>
            <br />
            <br />
          </>
        )}
      </React.Fragment>
    ));
  };

  return (
    <div className={styles.impactPage}>
      <Header />
      <main className={styles.impactContent}>
        <div className={styles.impactContainer}>
          <div className={styles.impactHeader}>
            <div className={styles.headerText}>
              <h1 className={styles.pageTitle}>{t("impact.title")}</h1>
              <p className={styles.pageSubtitle}>{t("impact.description")}</p>
            </div>
            <div className={styles.headerImages}>
              <img src="/images/impact/header-1.png" alt="" />
              <img src="/images/impact/header-2.jpg" alt="" />
              <img src="/images/impact/header-3.jpg" alt="" />
            </div>
            <div className={styles.headerImagesFull}>
              <img src="/images/impact/header-4.png" alt="" />
              <img src="/images/impact/header-5.png" alt="" />
            </div>
            <p className={styles.headerDescription}>
              {formatDescription(t("impact.headerDescription"))}
            </p>
          </div>

          <div className={styles.initiativesWrapper}>
            <section className={styles.initiativeSection}>
              <div className={styles.initiativeContent}>
                <div className={styles.initiativeText}>
                  <h2 className={styles.initiativeTitle}>
                    {t("impact.initiatives.stemOfTomorrow.title")}
                    <span className={styles.initiativeStats}> - {t("impact.initiatives.stemOfTomorrow.stats")}</span>
                  </h2>
                  <p className={styles.initiativeDescription}>
                    {formatDescription(
                      t("impact.initiatives.stemOfTomorrow.description")
                    )}
                  </p>
                </div>
                <div className={styles.imageGallery}>
                  <div className={styles.imageRow}>
                    <img src="/images/impact/stem-1.jpg" alt="" />
                    <img src="/images/impact/stem-2.jpg" alt="" />
                    <img src="/images/impact/stem-3.jpg" alt="" />
                  </div>
                  <div className={styles.imageRow}>
                    <img src="/images/impact/stem-4.png" alt="" />
                    <img src="/images/impact/stem-5.jpg" alt="" />
                    <img src="/images/impact/stem-6.jpg" alt="" />
                  </div>
                  <div className={styles.imageRow}>
                    <img src="/images/impact/stem-7.jpg" alt="" />
                    <img src="/images/impact/stem-8.jpg" alt="" />
                    <img src="/images/impact/stem-9.jpg" alt="" />
                  </div>
                  <div className={styles.imageRow}>
                    <img src="/images/impact/stem-10.png" alt="" />
                    <img src="/images/impact/stem-11.png" alt="" />
                    <img src="/images/impact/stem-12.jpg" alt="" />
                  </div>
                </div>
              </div>
            </section>

            <section className={styles.initiativeSection}>
              <div className={styles.initiativeContent}>
                <div className={styles.initiativeText}>
                  <h2 className={styles.initiativeTitle}>
                    {t("impact.initiatives.cysc.title")}
                    <span className={styles.initiativeStats}> - {t("impact.initiatives.cysc.stats")}</span>
                  </h2>
                  <p className={styles.initiativeDescription}>
                    {formatDescription(t("impact.initiatives.cysc.description"))}
                  </p>
                </div>
                <div className={styles.imageGallery}>
                  <div className={styles.imageRow}>
                    <img src="/images/impact/cysc-1.jpg" alt="" />
                    <img src="/images/impact/cysc-2.jpg" alt="" />
                    <img src="/images/impact/cysc-3.jpg" alt="" />
                  </div>
                  <div className={styles.imageRow}>
                    <img src="/images/impact/cysc-4.png" alt="" />
                    <img src="/images/impact/cysc-5.png" alt="" />
                    <img src="/images/impact/cysc-6.png" alt="" />
                  </div>
                </div>
              </div>
            </section>

            <section className={styles.initiativeSection}>
              <div className={styles.initiativeContent}>
                <div className={styles.initiativeText}>
                  <h2 className={styles.initiativeTitle}>
                    {t("impact.initiatives.cyfa1.title")}
                    <span className={styles.initiativeStats}> - {t("impact.initiatives.cyfa1.stats")}</span>
                  </h2>
                  <p className={styles.initiativeDescription}>
                    {formatDescription(t("impact.initiatives.cyfa1.description"))}
                  </p>
                </div>
                <div className={styles.imageGallery}>
                  <div className={styles.imageRow}>
                    <img src="/images/impact/cyfa-1.png" alt="" />
                    <img src="/images/impact/cyfa-2.jpg" alt="" />
                    <img src="/images/impact/cyfa-3.jpg" alt="" />
                  </div>
                  <div className={styles.imageRow}>
                    <img src="/images/impact/cyfa-4.jpg" alt="" />
                    <img src="/images/impact/cyfa-5.png" alt="" />
                    <img src="/images/impact/cyfa-6.png" alt="" />
                  </div>
                </div>
              </div>
            </section>

            <section className={styles.initiativeSection}>
              <div className={styles.initiativeContent}>
                <div className={styles.initiativeText}>
                  <h2 className={styles.initiativeTitle}>
                    {t("impact.initiatives.mediaReport.title")}
                  </h2>
                  <p className={styles.initiativeDescription}>
                    {formatDescription(t("impact.initiatives.mediaReport.description"))}
                  </p>
                </div>
                <div className={styles.imageGallery}>
                  <div className={styles.mediaImageRow}>
                    <img src="/images/impact/media-1.jpg" alt="" />
                    <img src="/images/impact/media-2.jpg" alt="" />
                    <img src="/images/impact/media-3.png" alt="" />
                  </div>
                  <div className={styles.mediaImageRow}>
                    <img src="/images/impact/media-4.png" alt="" />
                    <img src="/images/impact/media-5.png" alt="" />
                    <img src="/images/impact/media-6.png" alt="" />
                  </div>
                  <div className={styles.mediaImageRow}>
                    <img src="/images/impact/media-7.png" alt="" />
                    <img src="/images/impact/media-8.png" alt="" />
                    <img src="/images/impact/media-9.jpg" alt="" />
                  </div>
                </div>
              </div>
            </section>

            <section className={styles.initiativeSection}>
              <div className={styles.initiativeContent}>
                <div className={styles.initiativeText}>
                  <h2 className={styles.initiativeTitle}>
                    {t("impact.initiatives.cyfa2.title")}
                    <span className={styles.initiativeStats}> - {t("impact.initiatives.cyfa2.stats")}</span>
                  </h2>
                  <p className={styles.initiativeDescription}>
                    {formatDescription(t("impact.initiatives.cyfa2.description"))}
                  </p>
                </div>
                <div className={styles.imageGallery}>
                  <div className={styles.imageRow}>
                    <img src="/images/impact/cyfa2-1.png" alt="" />
                    <img src="/images/impact/cyfa2-2.png" alt="" />
                    <img src="/images/impact/cyfa2-3.png" alt="" />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Impact;
